(function() {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    if (cents == null || isNaN(cents)) return '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultTo(val, def) { return (val == null || val !== val) ? def : val; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }

    var value = '';
    var match = formatString.match(placeholderRegex);
    switch (match && match[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ' '); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function sanitizeHTML(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function fetchWithRetry(url, options, retries) {
    retries = retries || 3;
    var attempt = 0;
    return new Promise(function(resolve, reject) {
      function tryFetch() {
        fetch(url, options).then(function(response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        }).then(resolve).catch(function(error) {
          attempt++;
          if (attempt >= retries) return reject(error);
          setTimeout(tryFetch, 1000 * Math.pow(2, attempt - 1));
        });
      }
      tryFetch();
    });
  }

  function updateCartCount(count) {
    if (count === undefined) return;
    document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-link__count').forEach(function(el) {
      el.textContent = count;
      el.setAttribute('aria-label', count + ' items in cart');
    });
  }

  function handleAddToCart(e) {
    e.preventDefault();
    e.stopPropagation();
    var button = e.currentTarget;
    var productId = button.dataset.productId;
    var variantId = button.dataset.variantId;
    if (!productId || button.disabled || button.classList.contains('loading')) return;

    var buttonText = button.querySelector('span:last-child');
    var originalText = buttonText ? buttonText.textContent : 'Add to Cart';

    button.classList.add('loading');
    button.disabled = true;
    if (buttonText) buttonText.textContent = 'Adding...';

    fetchWithRetry('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ id: variantId || productId, quantity: 1 }),
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(cartData) {
      button.classList.remove('loading');
      button.classList.add('added');
      if (buttonText) buttonText.textContent = '\u2713 Added!';
      updateCartCount(cartData.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData }, bubbles: true }));
      if (window.Shopify && Shopify.onCartUpdate) Shopify.onCartUpdate(cartData);
      setTimeout(function() {
        button.classList.remove('added');
        if (buttonText) buttonText.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }).catch(function(error) {
      button.classList.remove('loading');
      button.classList.add('error');
      if (buttonText) buttonText.textContent = error.message || 'Error';
      setTimeout(function() {
        button.classList.remove('error');
        if (buttonText) buttonText.textContent = originalText;
        button.disabled = false;
      }, 3000);
    });
  }

  function initAddToCartButtons(sectionEl) {
    sectionEl.querySelectorAll('.collage-product-card__add-to-cart:not(:disabled)').forEach(function(button) {
      button.removeEventListener('click', handleAddToCart);
      button.addEventListener('click', handleAddToCart);
    });
  }

  function handlePlayClick(e) {
    e.preventDefault();
    var button = e.currentTarget;
    var wrapper = button.closest('.video-wrapper');
    if (!wrapper) return;
    var videoType = wrapper.dataset.videoType;
    var videoId = wrapper.dataset.videoId;
    var poster = wrapper.querySelector('.video-poster');
    var videoElement = wrapper.querySelector('.video-element');

    button.classList.add('play-button--hidden');
    if (poster) poster.classList.add('video-poster--hidden');

    if (videoType === 'uploaded') {
      var video = wrapper.querySelector('video');
      if (video) {
        video.muted = false;
        video.controls = true;
        video.play().catch(function(){});
      }
    } else if (videoType === 'youtube' && videoId) {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + sanitizeHTML(videoId) + '?autoplay=1&rel=0';
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      iframe.style.cssText = 'width:100%;height:100%;border:none;';
      iframe.setAttribute('title', 'YouTube video player');
      if (videoElement) { videoElement.innerHTML = ''; videoElement.appendChild(iframe); }
    } else if (videoType === 'vimeo' && videoId) {
      var iframe2 = document.createElement('iframe');
      iframe2.src = 'https://player.vimeo.com/video/' + sanitizeHTML(videoId) + '?autoplay=1';
      iframe2.allow = 'autoplay; fullscreen';
      iframe2.allowFullscreen = true;
      iframe2.style.cssText = 'width:100%;height:100%;border:none;';
      iframe2.setAttribute('title', 'Vimeo video player');
      if (videoElement) { videoElement.innerHTML = ''; videoElement.appendChild(iframe2); }
    }
  }

  function initVideoPlayers(sectionEl) {
    sectionEl.querySelectorAll('.collage__item--video .video-wrapper').forEach(function(wrapper) {
      var videoType = wrapper.dataset.videoType;
      var autoplay = wrapper.dataset.autoplay === 'true';
      var playButton = wrapper.querySelector('.play-button');
      if (!autoplay && playButton) {
        playButton.removeEventListener('click', handlePlayClick);
        playButton.addEventListener('click', handlePlayClick);
      }
      if (autoplay && videoType === 'uploaded') {
        var v = wrapper.querySelector('video');
        if (v) { v.muted = true; v.play().catch(function(){}); }
      }
    });
  }

  function resetContentAnimations(slider) {
    var wrapper = slider.querySelector('.hero-slider__content-wrapper');
    if (!wrapper) return;
    var animation = slider.dataset.animation || 'fade-in';
    var animClass = 'anim-' + animation.replace(/_/g, '-');
    wrapper.classList.remove(
      'anim-fade-in', 'anim-slide-up', 'anim-slide-down', 'anim-slide-left', 'anim-slide-right',
      'anim-zoom-in', 'anim-zoom-out', 'anim-rotate-in', 'anim-bounce-in', 'anim-elastic'
    );
    void wrapper.offsetWidth;
    wrapper.classList.add(animClass);
  }

  function initTypewriterEffect(heading, speed) {
    if (!heading || !heading.classList.contains('typewriter')) return null;
    var text = heading.getAttribute('data-typewriter-text') || heading.textContent;
    heading.textContent = '';
    var chars = text.split('');
    var i = 0;
    var interval = setInterval(function() {
      if (i < chars.length) { heading.textContent += chars[i]; i++; }
      else { clearInterval(interval); }
    }, speed);
    return interval;
  }

  function initProgressBar(slide, speed) {
    var progressBar = slide.querySelector('.hero-slider__progress-bar');
    if (!progressBar) return;
    progressBar.style.transition = 'none';
    progressBar.style.width = '0';
    void progressBar.offsetWidth;
    progressBar.style.transition = 'width ' + speed + 'ms linear';
    requestAnimationFrame(function() { progressBar.style.width = '100%'; });
  }

  function initCircularProgress(slider, currentIndex, speed) {
    var circularDots = slider.querySelectorAll('.hero-slider__circular-dot');
    if (!circularDots.length) return;
    circularDots.forEach(function(dot) {
      dot.classList.remove('active', 'progress');
      var fill = dot.querySelector('.hero-slider__circular-fill');
      if (fill) {
        fill.style.transition = 'none';
        fill.style.strokeDashoffset = '125.6';
        void fill.offsetWidth;
      }
    });
    var activeDot = circularDots[currentIndex];
    if (activeDot) {
      activeDot.classList.add('active');
      var fill2 = activeDot.querySelector('.hero-slider__circular-fill');
      if (fill2) {
        fill2.style.transition = 'stroke-dashoffset ' + speed + 'ms linear';
        requestAnimationFrame(function() { fill2.style.strokeDashoffset = '0'; });
      }
    }
  }

  function initHeroSliders(sectionEl) {
    sectionEl.querySelectorAll('.hero-slider').forEach(function(slider) {
      var slides = slider.querySelectorAll('.hero-slider__slide');
      var dots = slider.querySelectorAll('.hero-slider__dot');
      var circularDots = slider.querySelectorAll('.hero-slider__circular-dot');
      var prevBtn = slider.querySelector('.hero-slider__prev');
      var nextBtn = slider.querySelector('.hero-slider__next');
      var autoplay = slider.dataset.autoplay === 'true';
      var useCircular = slider.dataset.circularProgress === 'true';
      var speed = parseInt(slider.dataset.speed) || 5000;

      if (slides.length === 0) return;

      var currentSlide = 0;
      var interval = null;
      var isPaused = false;
      var typewriterInterval = null;
      var totalSlides = slides.length;

      function showSlide(index) {
        slides.forEach(function(s) { s.classList.remove('active'); s.setAttribute('aria-hidden', 'true'); });
        dots.forEach(function(d) { d.classList.remove('active'); d.setAttribute('aria-selected', 'false'); d.removeAttribute('aria-current'); });

        currentSlide = ((index % totalSlides) + totalSlides) % totalSlides;
        var activeSlide = slides[currentSlide];
        activeSlide.classList.add('active');
        activeSlide.setAttribute('aria-hidden', 'false');

        if (dots[currentSlide]) {
          dots[currentSlide].classList.add('active');
          dots[currentSlide].setAttribute('aria-selected', 'true');
          dots[currentSlide].setAttribute('aria-current', 'true');
        }

        resetContentAnimations(slider);
        initProgressBar(activeSlide, speed);
        if (useCircular) initCircularProgress(slider, currentSlide, speed);

        var highlightColor = activeSlide.getAttribute('data-highlight-color') || '#FFD700';
        activeSlide.querySelectorAll('.highlight-keyword').forEach(function(el) {
          el.style.setProperty('--highlight-color', highlightColor);
        });

        if (typewriterInterval) { clearInterval(typewriterInterval); typewriterInterval = null; }
        if (activeSlide.getAttribute('data-typewriter-effect') === 'true') {
          var heading = activeSlide.querySelector('.hero-slider__heading.typewriter');
          var typewriterSpeed = parseInt(activeSlide.getAttribute('data-typewriter-speed')) || 50;
          if (heading) typewriterInterval = initTypewriterEffect(heading, typewriterSpeed);
        }
      }

      function nextSlide() { if (!isPaused) showSlide(currentSlide + 1); }
      function prevSlide() { if (!isPaused) showSlide(currentSlide - 1); }

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          showSlide(i);
          if (autoplay && interval) { clearInterval(interval); interval = setInterval(nextSlide, speed); }
        });
      });

      circularDots.forEach(function(dot, i) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          showSlide(i);
          if (autoplay && interval) { clearInterval(interval); interval = setInterval(nextSlide, speed); }
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function(e) { e.preventDefault(); prevSlide(); });
      if (nextBtn) nextBtn.addEventListener('click', function(e) { e.preventDefault(); nextSlide(); });

      slider.setAttribute('tabindex', '0');
      slider.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); prevSlide(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); nextSlide(); }
      });

      var touchStartX = 0, touchEndX = 0;
      slider.addEventListener('touchstart', function(e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
      slider.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        if (touchEndX < touchStartX - 50) nextSlide();
        else if (touchEndX > touchStartX + 50) prevSlide();
      }, { passive: true });

      if (autoplay && totalSlides > 1) {
        interval = setInterval(nextSlide, speed);
        slider.addEventListener('mouseenter', function() { isPaused = true; if (interval) clearInterval(interval); });
        slider.addEventListener('mouseleave', function() { isPaused = false; if (interval) clearInterval(interval); interval = setInterval(nextSlide, speed); });
      }

      showSlide(0);
    });
  }

  function initQuickView(sectionEl, sectionId, moneyFormat) {
    var instanceId = sectionEl.dataset.instance;
    var overlay = document.querySelector('.shefs-qv-overlay-' + sectionId + '[data-instance="' + instanceId + '"]');
    var popup = document.querySelector('.shefs-qv-popup-' + sectionId + '[data-instance="' + instanceId + '"]');
    if (!overlay || !popup) return;

    var closeBtn = popup.querySelector('.shefs-qv-close-' + sectionId);
    var body = popup.querySelector('.shefs-qv-body-' + sectionId);
    var loading = popup.querySelector('.shefs-qv-loading-' + sectionId);
    var errorEl = popup.querySelector('.shefs-qv-error-' + sectionId);

    function openPopup(productHandle) {
      if (!productHandle) return;
      if (loading) loading.style.display = 'flex';
      if (errorEl) errorEl.classList.remove('is-visible');

      var oldProduct = popup.querySelector('.shefs-qv-product-' + sectionId);
      if (oldProduct) oldProduct.remove();

      overlay.classList.add('is-active');
      popup.classList.add('is-active');
      document.body.style.overflow = 'hidden';

      fetchWithRetry('/products/' + productHandle + '.js')
        .then(function(product) {
          if (loading) loading.style.display = 'none';
          renderProduct(product);
        })
        .catch(function() {
          if (loading) loading.style.display = 'none';
          if (errorEl) errorEl.classList.add('is-visible');
        });
    }

    function renderProduct(product) {
      var imageUrl = '';
      if (product.featured_image) {
        imageUrl = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
      } else if (product.images && product.images[0]) {
        imageUrl = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
      }

      var onSale = product.compare_at_price && product.compare_at_price > product.price;
      var priceFormatted = formatMoney(product.price, moneyFormat);
      var compareFormatted = product.compare_at_price ? formatMoney(product.compare_at_price, moneyFormat) : '';

      var availableVariants = product.variants ? product.variants.filter(function(v){ return v.available; }) : [];
      var firstVariant = availableVariants.length > 0 ? availableVariants[0] : null;

      var html = '<div class="shefs-qv-product-' + sectionId + '">';

      html += '<div class="shefs-qv-image-' + sectionId + '">';
      if (onSale) html += '<span class="shefs-qv-badge-' + sectionId + '">SALE</span>';
      if (imageUrl) html += '<img src="' + sanitizeHTML(imageUrl) + '" alt="' + sanitizeHTML(product.title || 'Product') + '" loading="lazy">';
      else html += '<div style="width:100%;height:300px;background:#f0f0f0;display:flex;align-items:center;justify-content:center;color:#999;">No image available</div>';
      html += '</div>';

      html += '<div class="shefs-qv-details-' + sectionId + '">';
      if (product.vendor) html += '<div class="shefs-qv-vendor-' + sectionId + '">' + sanitizeHTML(product.vendor) + '</div>';
      html += '<h2 class="shefs-qv-title-' + sectionId + '">' + sanitizeHTML(product.title || '') + '</h2>';
      html += '<div class="shefs-qv-price-' + sectionId + '">';
      if (onSale) {
        html += '<span class="shefs-qv-price-sale-' + sectionId + '">' + priceFormatted + '</span>';
        html += '<span class="shefs-qv-price-compare-' + sectionId + '">' + compareFormatted + '</span>';
      } else {
        html += '<span>' + priceFormatted + '</span>';
      }
      html += '</div>';

      if (product.description) {
        var desc = product.description.replace(/<[^>]*>/g, '').substring(0, 250);
        html += '<p class="shefs-qv-desc-' + sectionId + '">' + sanitizeHTML(desc) + '...</p>';
      }

      if (availableVariants.length > 1) {
        html += '<div><label class="shefs-qv-label-' + sectionId + '">Options</label><select class="shefs-qv-select-' + sectionId + '">';
        availableVariants.forEach(function(v) {
          html += '<option value="' + v.id + '">' + sanitizeHTML(v.title) + '</option>';
        });
        html += '</select></div>';
      }

      html += '<div class="shefs-qv-qty-' + sectionId + '"><label class="shefs-qv-label-' + sectionId + '">Qty</label><input type="number" class="shefs-qv-qty-input-' + sectionId + '" value="1" min="1" max="99"></div>';

      html += '<div class="shefs-qv-actions-' + sectionId + '">';
      if (firstVariant) {
        html += '<button class="shefs-qv-add-btn-' + sectionId + '" data-product-id="' + product.id + '" data-variant-id="' + firstVariant.id + '">';
        html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart</button>';
      } else {
        html += '<button class="shefs-qv-add-btn-' + sectionId + '" disabled>Sold Out</button>';
      }
      html += '<a href="' + sanitizeHTML(product.url) + '" class="shefs-qv-link-' + sectionId + '">View Full Details \u2192</a>';
      html += '</div></div></div>';

      body.insertAdjacentHTML('beforeend', html);

      var variantSelect = body.querySelector('.shefs-qv-select-' + sectionId);
      var addBtn = body.querySelector('.shefs-qv-add-btn-' + sectionId);
      var qtyInput = body.querySelector('.shefs-qv-qty-input-' + sectionId);

      if (variantSelect && addBtn) {
        variantSelect.addEventListener('change', function() { addBtn.dataset.variantId = this.value; });
      }

      if (addBtn) {
        addBtn.addEventListener('click', function() {
          var btn = this;
          if (btn.disabled || btn.classList.contains('is-loading')) return;
          var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
          btn.classList.add('is-loading');
          btn.innerHTML = 'Adding...';
          fetchWithRetry('/cart/add.js', {
            method: 'POST',
            body: JSON.stringify({ id: btn.dataset.variantId || btn.dataset.productId, quantity: qty }),
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          }).then(function(cart) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            btn.innerHTML = '\u2713 Added!';
            updateCartCount(cart.item_count);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
            setTimeout(closePopup, 1200);
          }).catch(function() {
            btn.classList.remove('is-loading');
            btn.classList.add('is-error');
            btn.innerHTML = 'Error';
            setTimeout(function() {
              btn.classList.remove('is-error');
              btn.innerHTML = 'Add to Cart';
            }, 2000);
          });
        });
      }
    }

    function closePopup() {
      overlay.classList.remove('is-active');
      popup.classList.remove('is-active');
      document.body.style.overflow = '';
      setTimeout(function() {
        var oldProduct = popup.querySelector('.shefs-qv-product-' + sectionId);
        if (oldProduct) oldProduct.remove();
        if (loading) loading.style.display = 'flex';
        if (errorEl) errorEl.classList.remove('is-visible');
      }, 300);
    }

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-active')) closePopup();
    });

    sectionEl.querySelectorAll('.collage-product-card__quick-view').forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = button.dataset.productHandle;
        if (handle) openPopup(handle);
      });
    });
  }

  function initSection(sectionEl) {
    var sectionId = sectionEl.dataset.sectionId;
    var moneyFormat = sectionEl.dataset.moneyFormat || '${{amount}}';
    if (!sectionId) return;

    sectionEl.querySelectorAll('[data-collage-section="true"]').forEach(function(c) {
      c.classList.add('collage--initialized');
    });

    try { initHeroSliders(sectionEl); } catch (e) { console.warn('Hero slider init:', e); }
    try { initVideoPlayers(sectionEl); } catch (e) { console.warn('Video init:', e); }
    try { initAddToCartButtons(sectionEl); } catch (e) { console.warn('Cart init:', e); }
    try { initQuickView(sectionEl, sectionId, moneyFormat); } catch (e) { console.warn('Quick view init:', e); }
  }

  function initAllSections() {
    document.querySelectorAll('[data-section-id][data-instance]').forEach(function(sectionEl) {
      if (sectionEl.dataset.shefsInitialized === 'true') return;
      sectionEl.dataset.shefsInitialized = 'true';
      initSection(sectionEl);
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      Promise.resolve().then(fn);
    }
  }

  onReady(function() {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            if (el.dataset.shefsInitialized !== 'true') {
              el.dataset.shefsInitialized = 'true';
              initSection(el);
            }
            observer.unobserve(el);
          }
        });
      }, { rootMargin: '100px 0px', threshold: 0.01 });

      document.querySelectorAll('[data-section-id][data-instance]').forEach(function(sectionEl) {
        observer.observe(sectionEl);
      });
    } else {
      initAllSections();
    }
  });

  document.addEventListener('shopify:section:load', function(e) {
    var sectionEl = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
    if (sectionEl) {
      sectionEl.dataset.shefsInitialized = 'true';
      initSection(sectionEl);
    }
  });
})();